<template>
  <material-card class=pt-2 full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-book-open-variant </v-icon>
          {{ student?.firstname + ' '+student?.lastname }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="enrollmentList" :headers="enrollmentsHeader" :loading="loading" item-key="enrollmentID"
      :search="search"  :page="pageNumber" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getEnrollments">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- custom columns -->
     
    </v-data-table>
    <template #actions>

    </template>
  </material-card>
</template>
<script>
export default {
  name: "BBBLiveEnrollments",
  props: {
    visible: Boolean,
    student: {
      type: Object,
      default: {}
    }
  },
  computed: {
   
  },
  data() {
    return {

      enrollmentsHeader: [
        { value: "course_course_id", text: this.$t("course_id") },
        { value: "course_course_name", text: this.$t("course_name") },
        { value: "course_professor_name", text: this.$t("professor_name") },
        { value: "course_total_unit", text: this.$t("total_unit") },
        { value: "course_theoretical_unit", text: this.$t("theoretical_unit") },
        { value: "course_practical_unit", text: this.$t("practical_unit") },
        { value: "course_term", text: this.$t("term") },
        { value: "course_is_active", text: this.$t("is_active") },
      ],
      enrollmentList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: []
    };
  },
  watch: {
   
  },
  methods: {
    getEnrollments() {
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/e_learning/students/"+this.student.id+"/enrollmentsv2",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
       
      })
        .then((response) => {
          let data = response.data;
          this.enrollmentList = data
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    
    close() {
      this.$emit('close')
    }
  },
  mounted() {
    this.getEnrollments();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  